module.exports = __webpack_public_path__ + "img/footer-fair-trade.3f19dd70.png";